(function(){
    'use strict'

    angular
    .module('app.feriados')
    .controller('EditarFeriado', EditarFeriado);

    EditarFeriado.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams','FeriadosService', 'logger', '$location', 'CoreSrv'];

    function EditarFeriado($q, $scope, $animationsSrv, $routeParams, FeriadosService, logger, $location, CoreSrv) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.feriadoId = $routeParams.id ? $routeParams.id : 0;

        vm.meses = CoreSrv.getMeses();
        vm.dias = CoreSrv.getDias();
        
        vm.feriado = {
            dia: -1,
            mes: -1,
            descripcion: '',
            pagoObligatorio: false
        };

        getFeriado();

        function getFeriado(){

            if(vm.feriadoId != 0){
                var promise = FeriadosService.getById(vm.feriadoId);

                promise
                .then(function(feriado){
                    vm.feriado = feriado;
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sesión ha expirado');
                            break;
                    
                        default:
                            logger.error('Hubo un error al obtener el feriado: ' + error.data.Message);
                            break;
                    }
                });               
            }                
        };

        function doFormValidations(){
            validateDia();
            validateMes();
        };

        vm.save = function(){

            $scope.submitted = true;
            
            doFormValidations();

            if($scope.feriadoForm.$valid){
                if(!vm.feriado.id){
                    saveFeriado();
                }
                else if($scope.feriadoForm.$dirty){
                    updateFeriado();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function saveFeriado() {
            var promise = FeriadosService.save(vm.feriado);
            
            promise
            .then(function(response){
                logger.success('Feriado creado con éxito.');
                clearFeriadoData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el feriado: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updateFeriado(){
            var promise = FeriadosService.update(vm.feriado);
            
            promise
            .then(function(response){
                logger.success('Feriado modificado con éxito.');
                $location.path('/feriados');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el feriado: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearFeriadoData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.feriado = {
                dia: -1,
                mes: -1,
                descripcion: '',
                pagoObligatorio: false
            };
            // Set back to pristine.
            $scope.feriadoForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.feriadoForm.$setUntouched();
        };

        function validateDia(){
            if(vm.feriado.dia == -1){
                $scope.feriadoForm.dia.$setValidity("different", false);
            }
            else{
                $scope.feriadoForm.dia.$setValidity("different", true);
            }
        };
        
        vm.diaChange = function(){
            validateDia();
        };

        function validateMes(){
            if(vm.feriado.mes == -1){
                $scope.feriadoForm.mes.$setValidity("different", false);
            }
            else{
                $scope.feriadoForm.mes.$setValidity("different", true);
            }
        };
        
        vm.mesChange = function(){
            validateMes();
        };

    }
})();